export default __webpack_public_path__ + "static/Gellix-Bold-0747a985ed24154e886f52d88ca3cde9.woff";